import Marquee from "react-fast-marquee";
import { Reveal, SectionLabel } from "./shared";

const Rates = () => (
  <section
    id="rates"
    data-testid="rates-section"
    className="relative bg-[#0a0a0a] py-24 lg:py-32 overflow-hidden"
  >
    <div className="opacity-[0.04] select-none pointer-events-none absolute inset-x-0 top-1/2 -translate-y-1/2">
      <Marquee autoFill speed={40}>
        <span className="font-display text-white font-extrabold uppercase text-[120px] tracking-tighter mx-8">
          Transparent &middot; Mutual &middot; Fair &middot;
        </span>
      </Marquee>
    </div>

    <div className="relative max-w-5xl mx-auto px-6 lg:px-8">
      <div className="flex justify-center mb-8">
        <SectionLabel number="03" title="Compensation" />
      </div>
      <Reveal>
        <div
          data-testid="rates-box"
          className="relative border border-[#d4af37] bg-[#0d0d0d]/80 backdrop-blur-sm p-10 lg:p-16 text-center shadow-[inset_0_0_60px_rgba(212,175,55,0.06)]"
        >
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#0a0a0a] px-4 font-display text-[#d4af37] text-xs tracking-[0.4em] uppercase">
            Rates
          </span>
          <h2 className="font-display text-white font-extrabold tracking-tighter uppercase text-3xl sm:text-4xl mb-8">
            Competitive &amp; Transparent
          </h2>
          <p className="text-[#cccccc] text-base sm:text-lg leading-relaxed max-w-3xl mx-auto">
            Competitive compensation packages tailored to the specific project
            scope, level of camera involvement, nature of performance required,
            and volume of content produced. All rates are transparently
            discussed, detailed, and mutually agreed upon in writing before any
            production begins.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Rates;
